<template>
    <v-autocomplete
        v-model="selectedProtocol"
        :items="filteredProtocols"
        label="Protocol (*)"
        return-object
        item-title="name"
        item-value="protocol_id"
        :rules="requiredSimpleValueRules('Protocol')"
    >
    </v-autocomplete>
</template>
<script setup lang="ts">
import _ from "lodash";
import { BenchlingProjectFolderOption, BenchlingProtocol } from "@/services/benchling/benchlingAPI";
import { ref, watch } from "vue";

import type { Ref } from "vue";
import { requiredSimpleValueRules } from "@/lib/validationUtils";

const props = defineProps<{
    projectFolderOption: BenchlingProjectFolderOption | undefined,
    protocols: BenchlingProtocol[]
}>();

const selectedProtocol = defineModel<BenchlingProtocol | undefined>();
const filteredProtocols: Ref<BenchlingProtocol[]> = ref([]);

watch(() => props.projectFolderOption, (selectedProjectFolder: BenchlingProjectFolderOption | undefined) => {
    if (selectedProjectFolder != null) {
        const projectId = selectedProjectFolder.projectId;
        filteredProtocols.value = _.filter(props.protocols, {
            project_id: projectId,
        });

        if (selectedProtocol.value && selectedProtocol.value.project_id !== projectId) {
            selectedProtocol.value = undefined;
        }
    } else {
        filteredProtocols.value = [];
        selectedProtocol.value = undefined;
    }
});

filteredProtocols.value = props.protocols;

</script>
